import { DateRange } from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';
import { formatDateRange } from '../../helpers/formatDateRange';
import { DatePickerMode } from '../../types';

export function getCalendarTitleByMode(
  dateRange: DateRange<dayjs.Dayjs>,
  datePickerMode: DatePickerMode | null,
): string {
  const [from, to] = dateRange;

  if (datePickerMode == null) {
    return '';
  }

  if (from == null || to == null) {
    return '';
  }

  if (datePickerMode === 'absolute') {
    return `${to?.diff(from, 'day') + 1} days`;
  }

  return `${formatDateRange(from, to)} (in UTC)`;
}
